import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@config/support/helpers/Lang';

export class TeamPredefinedTeam extends Enum {
  id!: null;
  name!: string;

  static PERSONAL_WORKSPACE: TeamPredefinedTeam = {
    id: null,
    get name(): string {
      return Lang.t('estate.private-space');
    }
  };
}
